import React from "react";
import LogoImage from "../../assets/images/pharma-logo.svg";

const Logo = (props) => {
  const { height, width } = props;
  return <img src={LogoImage} alt="logo" height={height} width={width} />;
};

export default Logo;
